import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';

function Footer({ selfClose, submitAlertFormEnabled, submitAlertForm, isEditMode, isMigrateMode }) {
  let buttonText;
  if (isEditMode) {
    buttonText = 'Save';
  } else if (isMigrateMode) {
    buttonText = 'Migrate';
  } else {
    buttonText = 'Create';
  }

  return (
    <div className="els-btn-group-right">
      <ButtonWithIcon type="tertiary" sprite="ChevronRight" onClick={selfClose} className="e2e-create-alert-cancel">
        Cancel
      </ButtonWithIcon>

      <ButtonWithIcon
        type="primary"
        sprite="ChevronRight"
        onClick={submitAlertForm}
        disabled={!submitAlertFormEnabled}
        className="e2e-create-alert-create">
        {buttonText}
      </ButtonWithIcon>
    </div>
  );
}

Footer.propTypes = {
  selfClose: PropTypes.func.isRequired,
  submitAlertFormEnabled: PropTypes.bool,
  submitAlertForm: PropTypes.func.isRequired,
  isEditMode: PropTypes.bool,
  isMigrateMode: PropTypes.bool,
};

export default React.memo(Footer);
